import React, {useEffect, useState, useContext} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {BaseURL} from "../../../../Files/BaseURL";
import AlertContext from '../../../../Context/Alert/AlertContext';

const Review = () => {
    const location = useLocation();
    const amount = location.state.amount;
    const email = location.state.email;
    const [tax, setTax] = useState(0.00);
    const {showAlert} = useContext(AlertContext);
    const navigate = useNavigate();

    const taxInfo = async() =>{
        try{
            const result = await fetch(`${BaseURL}/api/payment/withdraw-tax-info`,{
                headers:{
                    "auth-token": localStorage.getItem('p@token')
                }
            })
            if(result.ok){
                const data = await result.json();
                const value = Number((data.FeePercen/100)*amount).toFixed(2)
                setTax(value);
            }
        }
        catch(error){
            console.error(error.message);
        }
    }

    useEffect(() => {
        taxInfo();
    }, []);

    const handleClick = async () => {
        try{
            const result = await fetch(`${BaseURL}/api/withdraw/withdraw-request//withdraw-request`,{
                method: 'POST',
                headers:{
                    'Content-Type': 'application/json',
                    'auth-token': localStorage.getItem('p@token')
                },
                body: JSON.stringify({amount: amount ,tax:tax, Email: email})
            })
            if(!result.ok){
                showAlert('Error in processing the request');
                return;
            }
            navigate('/user-dashboard/withdraw/success')
        }
        catch(error){
            console.error(error.message);
        }

    }
    return (
        <div className="flex justify-center font-pop items-center py-20">
            <div className="mx-6 bg-white max-w-md w-full p-8 rounded-lg shadow-md">
            <h2 className="text-lg md:text-2xl font-pop font-semibold mb-4">Withdraw money</h2>
                {/* <form> */}

                <div className="flex flex-col font-pop gap-4">
                    <div className="flex flex-row gap-2">
                        <div className="bg-primarygreen rounded-full w-4 md:w-6 h-4 md:h-6"></div>
                        <div className="flex flex-col gap-1" >
                            <h2 className="text-base md:text-lg font-bold">Withdraw from Paycott balance</h2>
                            <p className="text-gray-600 text-xs md:text-sm max-w-sm">{amount && Number(amount).toFixed(2)} USD</p>
                        </div>
                    </div>
                    <div className="flex flex-row gap-2">
                        <div className="bg-primarygreen rounded-full w-4 md:w-6 h-4 md:h-6"></div>
                        <div className="flex flex-col gap-1" >
                            <h2 className="text-base md:text-lg font-bold">Fee</h2>
                            <p className="text-gray-600 text-xs md:text-sm max-w-sm">{tax} USD</p>
                        </div>
                    </div>
                    <div className="flex flex-row gap-2">
                        <div className="bg-primarygreen rounded-full w-4 md:w-6 h-4 md:h-6"></div>
                        <div className="flex flex-col gap-1" >
                            <h2 className="text-base md:text-lg font-bold">Deposit to your Account</h2>
                            <p className="text-gray-600 text-xs md:text-sm max-w-sm">{amount && Number(amount - tax).toFixed(2)} USD</p>
                        </div>
                    </div>
                    <button className="my-4 w-full bg-green-500 hover:bg-transparent  hover:bg-white-500 font-semibold hover:text-black font-pop text-lg md:text-xl py-1 md:py-3 px-4 border border-black-500 hover:border-green-500 rounded-full  text-white animate__animated animate__backInUp "
                        onClick={handleClick}>
                            Withdraw
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Review